var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoldingMirrors32 = function SvgFoldingMirrors32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.813h3.837v-2.095A3.686 3.686 0 0 1 7.22 8.837a3.796 3.796 0 0 1 3.13-.76l13.928 2.811c.83.168 1.578.61 2.122 1.25.545.643.855 1.447.88 2.285l.718 6.75a3.683 3.683 0 0 1-1.06 2.7A3.794 3.794 0 0 1 24.24 25H10.177a3.778 3.778 0 0 1-2.657-1.089 3.698 3.698 0 0 1-1.1-2.629H3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.002 12.266.566 8.459c-.015.322.1.638.323.877.222.24.531.382.86.398h13.064c.33-.016.64-.159.861-.398.222-.24.338-.555.323-.877l-.298-3.05-.269-2.772a1.233 1.233 0 0 0-.258-.794 1.28 1.28 0 0 0-.71-.46l-3.151-.637-9.91-1.999a1.248 1.248 0 0 0-1.005.3 1.176 1.176 0 0 0-.396.953v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9v2.562c0 .714-.147 1.42-.432 2.08a5.428 5.428 0 0 1-1.231 1.765 5.701 5.701 0 0 1-1.842 1.179 5.896 5.896 0 0 1-2.173.414H20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.108 16.91 3.38-1.863a.465.465 0 0 1 .33-.028.311.311 0 0 1 .132.074c.032.032.05.07.05.108v3.596a.154.154 0 0 1-.047.108.3.3 0 0 1-.127.075.455.455 0 0 1-.327-.024l-3.383-1.733a.249.249 0 0 1-.084-.07.15.15 0 0 1-.032-.085c0-.03.009-.06.027-.087a.24.24 0 0 1 .081-.07Z",
    fill: "currentColor"
  })));
};
export default SvgFoldingMirrors32;